import { Button } from "@mui/material"
import LogoutIcon from '@mui/icons-material/Logout';
import { signOut } from "@utils/auth";
import authService from "services/authService";


const Logout = () => {
    const handleLogout = () => {
        signOut();
        authService.logout();
    }
    return (
      <Button
            variant="outlined"
            color="error"
            startIcon={<LogoutIcon />}
            sx={{
            textTransform: "none",
            borderRadius: "20px",
            px: 2,
            fontWeight: 500,
            "&:hover": {
                backgroundColor: "#ffecec",
                borderColor: "#EB4335",
            },
            }}
            onClick={handleLogout}
        >
            Logout
        </Button>
    )
}

export default Logout